import { convert, LocalDate, LocalDateTime, LocalTime, nativeJs, ZonedDateTime } from '@js-joda/core';

type DateInput = Date | string;

const toZonedDateTime = (input: DateInput): ZonedDateTime => {
   const date = typeof input === 'string' ? new Date(input) : input;

   if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
      throw new TypeError('Invalid date input.');
   }

   return nativeJs(date);
};

export const convertDateToLocalDate = (input: DateInput): LocalDate => LocalDate.from(toZonedDateTime(input));

export const convertDateToLocalTime = (input: DateInput): LocalTime => LocalTime.from(toZonedDateTime(input));

export const convertDateToLocalDateTime = (input: DateInput): LocalDateTime =>
   LocalDateTime.from(toZonedDateTime(input));

export const convertLocalDateTimeToDate = (localDateTime: LocalDateTime): Date => convert(localDateTime).toDate();
